module.exports = __webpack_public_path__ + "img/empty.686d3a87.png";